import uniqueId from 'lodash/uniqueId';

const renderTestId = (id: string) => {
  if (process.env.NODE_ENV !== 'test') {
    return {};
  }

  return {
    'data-selector': id,
  };
};

const testIdQuery = (id: string, {exact}: {exact?: boolean} = {exact: true}) =>
  `[data-selector${exact ? '' : '^'}="${id}"]`;

const prefixedTestId = <T = number | string>(id: string) => {
  const randomId = uniqueId();

  return (prefix: T) => `${randomId}_${id}${prefix ? `_${prefix}` : ''}`;
};

const booleanTestId = (id: string, booleanId: string) => {
  const randomId = uniqueId();

  return (predicate?: boolean) => `${randomId}_${id}${predicate ? `_${booleanId}` : ''}`;
};

export {renderTestId, testIdQuery, prefixedTestId, booleanTestId};
